<template>
  <div v-if="isLoaded">

    <!--    <transition name="fade">-->
    <!--      <div class="row" v-if="moduleInfoMessage">-->
    <!--        <div class="col-12">-->
    <!--          <div style="-->
    <!--                color: rgb(90, 90, 90);-->
    <!--                font-size: 16px;-->
    <!--                padding: 10px;-->
    <!--                background: #F8F8F8;-->
    <!--                border: 1px solid rgb(90, 90, 90);-->
    <!--                margin-bottom: 20px;-->
    <!--                border-radius: 3px">-->
    <!--            {{ moduleInfoMessage }}-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </transition>-->

    <transition name="fade">
      <div class="row" v-if="unitsErrorMessage || terminErrorMessage || moduleUnitsErrorMessage">
        <div class="col-12">
          <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
            {{ unitsErrorMessage }} {{ terminErrorMessage }} {{ moduleUnitsErrorMessage }}
          </div>
        </div>
      </div>
    </transition>

    <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
      <div class="col text-right" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
      <div class="col-auto text-right">
        <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
      </div>
    </div>

    <form @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
          <Datepicker
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              v-model="formData.termin"
              :required="true"
              label="Termin"
              position="down"
              :validation="v$.termin"
              :messages="v$.termin.required.$message"
              @update:modelValue="onChangeTermin"/>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12  ">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :key="startTimeKey"
                  :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                  v-model="formData.startTime"
                  :required="true"
                  :hoursArray=hoursArrayDropdown
                  :minutesArray=minutesArrayDropdown
                  label="Startzeit"
                  @update:modelValue="calculateTimeDifference"/>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :key="endTimeKey"
                  :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                  v-model="formData.endTime"
                  :required="true"
                  :hoursArray=hoursArrayDropdown
                  :minutesArray=minutesArrayDropdown
                  label="Endzeit"
                  @update:modelValue="calculateTimeDifference"/>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue v-model="formData.presence"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="presenceDropdown"
                     :required="true"
                     label="Anwesenheit"
                     placeholder="Wählen Sie Anwesenheit"
                     :validation="v$.presence"
                     :messages="v$.presence.required.$message"
                     @update:modelValue="onChangePresence"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseNumber
              v-model="formData.units"
              label="Einheiten"
              disabled="disabled"/>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseCheckbox
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting || isDigitalSignature"
              v-model="formData.signature"
              label="Unterschrift"
              :labelPosition="'right'"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <BaseCheckbox
              :disabled="isBilled || isSystemAddedMeeting"
              v-model="formData.billed"
              label="Abgerechnet"
              :labelPosition="'right'"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <BaseCheckbox
              :disabled="isSystemAddedMeeting || isCoachBilled"
              v-model="formData.paid"
              label="Bezahlt"
              :labelPosition="'right'"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseCheckbox
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              v-model="formData.homeVisit"
              label="Hausbesuch"
              :labelPosition="'right'"/>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-lg-4 col-md-8 col-sm-12"
             v-if="
                 ( currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_ACCOUNTANT') && !originalIsSystemAddedMeeting">
          <SelectVue v-model="formData.coachId"
                     :disabled="isCoachBilled"
                     :options="coachDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Coach"
                     placeholder="Trainer auswählen"/>
        </div>
      </div>

      <!-- GOALS FROM PREVIOUS MEETING  -->
      <div class="row mt-4" style="border-top: 1px solid #D8D8D8" v-if="formData.moduleGoal4IdFromLastMeeting">
        <div class="col-lg-6 col-md-12 col-sm-12 mt-3">
          <SelectVue v-model="formData.moduleGoal5IdFromLastMeeting"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleGoal5LastMeetingDropdown"
                     :is-clear="true"
                     label="Kontrolle vereinbarte Ziele"
                     placeholder="Wählen Sie Modulziel"
                     @update:modelValue="onChangeGoalFromLastMeeting"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 mt-3">
          <SelectVue v-model="formData.moduleGoal6IdFromLastMeeting"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleGoal6LastMeetingDropdown"
                     :is-clear="true"
                     label="Handlungsempfehlung"
                     placeholder="Wählen Sie Modulziel"/>
        </div>
      </div>


      <div class="row mt-4" style="border-top: 1px solid #D8D8D8">
        <div class="col-lg-4 col-md-8 col-sm-12 mt-3">
          <SelectVue v-model="formData.moduleId"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Modul"
                     placeholder="Modul auswählen"
                     :validation="v$.moduleId"
                     :messages="v$.moduleId.required.$message"
                     @update:modelValue="onChangeModule"/>
        </div>
        <div v-if="(currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') && protocolId"
             class="col-lg-2 col-md-4 col-sm-12 mt-3">
          <BaseNumber
              v-model="formData.sectionNumber"
              :validation="v$.sectionNumber"
              :messages="v$.sectionNumber?.required?.$message"
              :label="$t('general.section_number')"
              :disabled="!updateAsAdmin"/>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <SelectVue v-model="formData.moduleGoal1Id"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleGoal1Dropdown"
                     :required="true"
                     :is-clear="true"
                     label="Richtziel"
                     placeholder="Wählen Sie Modulziel"
                     @update:modelValue="(newValue) => onChangeGoal(newValue, 1)"
                     :validation="v$.moduleGoal1Id"
                     :messages="v$.moduleGoal1Id?.required?.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <SelectVue v-model="formData.moduleGoal2Id"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleGoal2Dropdown"
                     :required="true"
                     :is-clear="true"
                     label="Grobziel"
                     placeholder="Wählen Sie Modulziel"
                     @update:modelValue="(newValue) => onChangeGoal(newValue, 2)"
                     :validation="v$.moduleGoal2Id"
                     :messages="v$.moduleGoal2Id?.required?.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <SelectVue v-model="formData.moduleGoal3Id"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleGoal3Dropdown"
                     :required="true"
                     :is-clear="true"
                     label="Feinziel"
                     placeholder="Wählen Sie Modulziel"
                     @update:modelValue="(newValue) => onChangeGoal(newValue, 3)"
                     :validation="v$.moduleGoal3Id"
                     :messages="v$.moduleGoal3Id?.required?.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <SelectVue v-model="formData.moduleGoal4Id"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleGoal4Dropdown"
                     :required="true"
                     :is-clear="true"
                     label="Maßnahmen"
                     placeholder="Wählen Sie Modulziel"
                     @update:modelValue="(newValue) => onChangeGoal(newValue, 4)"
                     :validation="v$.moduleGoal4Id"
                     :messages="v$.moduleGoal4Id?.required?.$message"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-8 col-sm-12">
          <Datepicker
              v-model="formData.moduleGoalDate"
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              label="Bis wann"
              position="down"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <SelectVue v-model="formData.moduleGoal5Id"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleGoal5Dropdown"
                     :is-clear="true"
                     label="Zielkontrolle"
                     placeholder="Wählen Sie Modulziel"
                     @update:modelValue="(newValue) => onChangeGoal(newValue, 5)"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <SelectVue v-model="formData.moduleGoal6Id"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleGoal6Dropdown"
                     :is-clear="true"
                     label="Handlungsempfehlung"
                     placeholder="Wählen Sie Modulziel"
                     @update:modelValue="(newValue) => onChangeGoal(newValue, 6)"/>
        </div>
      </div>


      <div v-if="formData.presenceRemainder" class="mt-2">
        <BaseTextArea v-model="formData.presenceRemainder"
                      disabled="disabled"
                      label="Prüfung Anwesenheit"/>
      </div>
      <div v-if="showAdditionalDropdown" class="col-lg-4 col-md-8 col-sm-12 pl-0">
        <SelectVue v-model="formData.presenceRemainderAcceptance"
                   :options="generatePresenceRemainderAcceptanceDropdown"
                   :is-clear="true"
                   disabled=disabled
                   placeholder="Wählen Sie ..."/>
      </div>
      <div v-if="formData.systemAddedMeetingDescription" class="mt-3">
        <BaseInput v-model="formData.systemAddedMeetingDescription"
                   disabled=disabled
                   label="Selbstlernphase Anwesenheit"/>
      </div>

      <div class="row mt-3">
        <div class="col-12 mb-2">
          <span style="font-size: 16px; text-decoration: underline">Beschreibung des Modulziels</span>
        </div>
        <div class="col-12 mb-2">
          <span style="font-weight: bolder; margin-right: 15px;">Richtziel:</span>{{ goal1Name }} <span
            class="moduleGoal1Name pl-1"></span>
        </div>
        <div class="col-12 mb-2">
          <span style="font-weight: bolder;  margin-right: 15px;">Grobziel:</span> {{ goal2Name }} <span
            class="moduleGoal2Name pl-1"></span>
        </div>
        <div class="col-12 mb-2">
          <span style="font-weight: bolder;  margin-right: 15px;">Feinziel:</span> {{ goal3Name }} <span
            class="moduleGoal3Name pl-1"></span>
        </div>
        <div class="col-12 mb-2">
          <span style="font-weight: bolder;  margin-right: 15px;"> Maßnahmen:</span> {{ goal4Name }} <span
            class="moduleGoal4Name pl-1"></span>
        </div>
        <div class="col-12 mb-2">
          <span style="font-weight: bolder;  margin-right: 15px;"> Handlungsempfehlung:</span> {{ goal6Name }} <span
            class="moduleGoal6Name pl-1"></span>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12 d-flex justify-content-end">
          <BaseCheckbox
              v-model="formData.geva"
              label="Potentialanalyse"
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              :labelPosition="'right'"/>
        </div>
      </div>

      <ValidationErrorMessage :validationErrors=v$?.$errors></ValidationErrorMessage>

      <div v-if="!unitsErrorMessage && !terminErrorMessage && !moduleUnitsErrorMessage"
           class="d-flex justify-content-center w-100 mt-3">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import dropdownService from '@/api/Dropdown';
import portalPrivateCoachingService from '@/api/Portal/PrivateCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import BaseTextArea from '@/components/base/BaseTextArea.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import ValidationErrorMessage from '@/components/ValidationErrorMessage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {addDeletedCoachToDropdown, addDeletedModuleToDropdown} from '@/shared/portal/commonFunctions';
import {
  generateHoursArray,
  generatePresenceRemainderAcceptanceDropdown,
  handleGoalChange,
  portalPrivateCoachingCheckModule,
} from '@/shared/portal/privateCoachingFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs} from 'vue';
import {useI18n} from 'vue-i18n';
import BaseToggle from "@/components/base/BaseToggle.vue";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import router from "@/router";
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyKey = companySettings.value.companyKey;

const {t} = useI18n();
const coachDropdown = ref([]);
const presenceDropdown = ref([]);
const moduleDropdown = ref([]);
const moduleGoal1Dropdown = ref([]);
const moduleGoal2Dropdown = ref([]);
const moduleGoal3Dropdown = ref([]);
const moduleGoal4Dropdown = ref([]);
const moduleGoal5Dropdown = ref([]);
const moduleGoal6Dropdown = ref([]);
const moduleGoal5LastMeetingDropdown = ref([]);
const moduleGoal6LastMeetingDropdown = ref([]);
const goal1Name = ref('');
const goal2Name = ref('');
const goal3Name = ref('');
const goal4Name = ref('');
const goal6Name = ref('');
const unitsErrorMessage = ref('');
const terminErrorMessage = ref('');
const moduleUnitsErrorMessage = ref('');
const moduleInfoMessage = ref('');
const showAdditionalDropdown = ref(false);
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const isSystemAddedMeeting = ref(false);
const isProcessingChangeTermin = ref(false);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);
const updateAsAdmin = ref(false)
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic
const originalIsSystemAddedMeeting = ref(false) // Need this for update as admin logic

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  protocolId: {
    type: [Number, String],
    required: true,
  },
  operationType: {
    type: String,
    required: true,
  },
  isUnitsReduction: {
    type: Boolean,
    required: true
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  isDigitalSignature: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const coaching = toRefs(props)['coaching'];
const coachingId = computed(() => +coaching.value.id);
const protocolId = toRefs(props)['protocolId'];
const operationType = toRefs(props)['operationType'];
const isUnitsReduction = toRefs(props)['isUnitsReduction'];

const formData = ref({
  coachingId: '',
  operationType: '',
  termin: '',
  startTime: '07:00',
  endTime: '07:00',
  presence: '',
  units: 0,
  signature: false,
  billed: false,
  paid: false,
  homeVisit: false,
  coachId: null,
  moduleId: null,
  sectionNumber: null,
  geva: false,
  moduleGoal1Id: null,
  moduleGoal2Id: null,
  moduleGoal3Id: null,
  moduleGoal4Id: null,
  moduleGoal5Id: null,
  moduleGoal6Id: null,
  moduleGoalDate: null,
  lastMeetingId: null,
  moduleIdFromLastMeeting: null,
  moduleGoal4IdFromLastMeeting: null,
  moduleGoal5IdFromLastMeeting: null,
  moduleGoal6IdFromLastMeeting: null,
  systemAddedMeetingDescription: '',
  presenceRemainder: '',
  presenceRemainderAcceptance: '',
});

const originalFormData = ref({});
const originalModuleGoalDropdowns = ref([])
// This key will force the Timepicker to re-create when changed
const startTimeKey = ref(formData.value.startTime);
const endTimeKey = ref(formData.value.endTime);

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  units: requiredRule(t),
  moduleId: requiredRule(t),
  moduleGoal1Id: requiredRule(t),
  moduleGoal2Id: requiredRule(t),
  moduleGoal3Id: requiredRule(t),
  moduleGoal4Id: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = coachingId.value;
    formData.value.operationType = operationType.value;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer
    formData.value.systemAddedMeeting = originalIsSystemAddedMeeting.value // Need this for update as admin

    formData.value.moduleGoal1Id = normalizeId(formData.value.moduleGoal1Id);
    formData.value.moduleGoal2Id = normalizeId(formData.value.moduleGoal2Id);
    formData.value.moduleGoal3Id = normalizeId(formData.value.moduleGoal3Id);
    formData.value.moduleGoal4Id = normalizeId(formData.value.moduleGoal4Id);
    formData.value.moduleGoal5Id = normalizeId(formData.value.moduleGoal5Id);
    formData.value.moduleGoal6Id = normalizeId(formData.value.moduleGoal6Id);
    formData.value.moduleGoal5IdFromLastMeeting = normalizeId(formData.value.moduleGoal5IdFromLastMeeting);
    formData.value.moduleGoal6IdFromLastMeeting = normalizeId(formData.value.moduleGoal6IdFromLastMeeting);

    if (props.protocolId) {
      if (updateAsAdmin.value) {
        await portalPrivateCoachingService.updateAsAdminMICV2Protocol(formData.value, +protocolId.value);
      } else {
        await portalPrivateCoachingService.updateMICV2Protocol(formData.value, +protocolId.value);
      }
    } else {
      await portalPrivateCoachingService.postMICV2Protocol(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getProtocolData(protocolId) {
  try {
    const {data} = await portalPrivateCoachingService.getProtocolData(protocolId.value);
    const {protocol} = data?.data;
    const additionalDropdown = data.data.showAdditionalDropdown;
    const moduleGoalDropdowns = protocol.moduleGoalDropdownOptions;

    isBilled.value = protocol.invoiced;
    isCoachBilled.value = protocol.coachInvoiced;

    // Save original values
    originalIsBilled.value = protocol.invoiced;
    originalIsCoachBilled.value = protocol.coachInvoiced;
    originalIsSystemAddedMeeting.value = protocol.systemAddedMeeting

    isSystemAddedMeeting.value = protocol.systemAddedMeeting;
    showAdditionalDropdown.value = additionalDropdown;

    moduleGoal1Dropdown.value = moduleGoalDropdowns?.goal1Dropdown || [];
    moduleGoal2Dropdown.value = moduleGoalDropdowns?.goal2Dropdown || [];
    moduleGoal3Dropdown.value = moduleGoalDropdowns?.goal3Dropdown || [];
    moduleGoal4Dropdown.value = moduleGoalDropdowns?.goal4Dropdown || [];
    moduleGoal5Dropdown.value = moduleGoalDropdowns?.goal5Dropdown || [];
    moduleGoal6Dropdown.value = moduleGoalDropdowns?.goal6Dropdown || [];
    moduleGoal5LastMeetingDropdown.value = moduleGoalDropdowns?.goal5FromLastMeetingDropdown || [];
    moduleGoal6LastMeetingDropdown.value = moduleGoalDropdowns?.goal6FromLastMeetingDropdown || [];
    goal1Name.value = protocol?.moduleGoal1?.name;
    goal2Name.value = protocol?.moduleGoal2?.name;
    goal3Name.value = protocol?.moduleGoal3?.name;
    goal4Name.value = protocol?.moduleGoal4?.name;
    goal6Name.value = protocol?.moduleGoal6?.name;

    addDeletedCoachToDropdown(protocol.coach, coachDropdown);
    addDeletedModuleToDropdown(protocol.module, moduleDropdown);

    if (protocol.presence === 'unentschuldigt' || protocol.presence === 'krank') {
      formRules.value = {
        ...formRules.value,
        moduleGoal1Id: '',
        moduleGoal2Id: '',
        moduleGoal3Id: '',
        moduleGoal4Id: '',
      };
    } else {
      formRules.value = {
        ...formRules.value,
        moduleGoal1Id: requiredRule(t),
        moduleGoal2Id: requiredRule(t),
        moduleGoal3Id: requiredRule(t),
        moduleGoal4Id: requiredRule(t),
      };
    }

    formData.value = {
      ...protocol,
      coachId: protocol?.coach?.id,
      moduleId: protocol?.module?.id,
      lastMeetingId: protocol.previousMeetingId,
      moduleGoal1Id: protocol?.moduleGoal1?.id ? +protocol?.moduleGoal1?.id : null,
      moduleGoal2Id: protocol?.moduleGoal2?.id ? +protocol?.moduleGoal2?.id : null,
      moduleGoal3Id: protocol?.moduleGoal3?.id ? +protocol?.moduleGoal3?.id : null,
      moduleGoal4Id: protocol?.moduleGoal4?.id ? +protocol?.moduleGoal4?.id : null,
      moduleGoal5Id: protocol?.moduleGoal5?.id ? +protocol?.moduleGoal5?.id : null,
      moduleGoal6Id: protocol?.moduleGoal6?.id ? +protocol?.moduleGoal6?.id : null,
      moduleIdFromLastMeeting: protocol?.moduleFromLastMeeting?.id,
      moduleGoal4IdFromLastMeeting: protocol?.moduleGoal4FromLastMeeting?.id ? +protocol?.moduleGoal4FromLastMeeting?.id : null,
      moduleGoal5IdFromLastMeeting: protocol?.moduleGoal5FromLastMeeting?.id ? +protocol?.moduleGoal5FromLastMeeting?.id : null,
      moduleGoal6IdFromLastMeeting: protocol?.moduleGoal6FromLastMeeting?.id ? +protocol?.moduleGoal6FromLastMeeting?.id : null,
    };

    // store original as a deep copy !!!
    originalFormData.value = JSON.parse(JSON.stringify(formData.value));
    originalModuleGoalDropdowns.value = JSON.parse(JSON.stringify(moduleGoalDropdowns));
  } catch (error) {
    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    await ErrorToast(error);
  }
}

async function getAssignedCoachesForDropdown() {
  try {
    CloseToast();
    const {data} = await dropdownService.getPrivateCoachingAssignedCoaches(coachingId.value);

    coachDropdown.value = data.data.map(item => ({
      label: `${item.firstName}` + ' ' + `${item.lastName}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getAssignedModulesForDropdown() {
  try {
    CloseToast();
    const {data} = await dropdownService.getPrivateCoachingAssignedModules(coachingId.value);
    moduleDropdown.value = data.data.map(item => ({
      label: `${item.name}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

const calculateTimeDifference = () => {

  if (formData.value.startTime && formData.value.endTime) {
    moduleInfoMessage.value = '';

    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);

    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const diffMinutes = endTotalMinutes - startTotalMinutes;

    let units = (diffMinutes / 45).toPrecision(3).substring(0, 4);

    onChangeUnits(units); // Check if units are round

    const parsedValue = parseFloat(units);

    if (parsedValue === 1 || parsedValue === 2) { // Units must be 1 or 2
      units = (diffMinutes / 45).toPrecision(3).substring(0, 4);

      if (
          isUnitsReduction.value &&
          formData.value.presence &&
          formData.value.presence !== 'anwesend'
      ) {
        units = 1;
      } else {
        units = (diffMinutes / 45).toPrecision(3).substring(0, 4);
      }

      onChangeModule(formData.value.moduleId);
    }

    formData.value.units = Number(units).toFixed(2);
  } else {
    formData.value.units = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else if (!Number.isInteger(parsedValue)) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else if (parsedValue > 2) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else {
    unitsErrorMessage.value = '';
  }
}

async function onChangeTermin(newTermin) {

  if (isProcessingChangeTermin.value) return;
  if (!coaching.value?.id) return;
  isProcessingChangeTermin.value = true;

  try {
    // 1. Check if the last meeting is system added meeting
    formData.value.systemAddedMeetingDescription = '';
    if (newTermin) {

      const [day, month, year] = newTermin.split('.');
      const formattedDate = `${year}-${month}-${day}`;

      const {data} = await portalPrivateCoachingService.checkIsLastMeetingSystemAddedMeeting(
          coachingId.value, formattedDate, protocolId.value,
      );

      if (data?.data?.lastMeetingIsSystemAddedMeeting === true && coaching.value.status !== 'new') {
        formData.value.systemAddedMeetingDescription = 'Über die durchgeführte Selbstlerneinheit wurde mit dem Teilnehmer gesprochen.';
      }
    }

    // 2. Check meeting presence
    await onChangePresence(formData.value.presence);

    // 3. Get goals from last meeting
    await getGoalsFromLastMeeting();
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isProcessingChangeTermin.value = false;
  }

}

async function onChangeModule(newValue) {
  try {
    if (newValue) {
      if (formData.value.moduleId !== newValue) {
        clearModuleData()
      }

      // const {data} = await portalPrivateCoachingService.getSumUnitsDoneForModule(
      //     +coachingId,
      //     +newValue,
      //     protocolId.value,
      // );

      // const [errorMessage, infoMessage] = portalPrivateCoachingCheckModule(data, formData, updateAsAdmin.value);
      //
      // moduleInfoMessage.value = infoMessage;
      // moduleUnitsErrorMessage.value = errorMessage;

      const {data: goals} = await portalPrivateCoachingService.getGoalsOnChangeModuleOrGoal(+newValue);

      moduleGoal1Dropdown.value =
          goals?.data?.moduleGoals?.filter(item => item.shortName) // Exclude items with empty shortName
              .map(item => ({
                label: item.shortName,
                value: item?.id,
              }));

    } else {
      moduleInfoMessage.value = '';
      moduleUnitsErrorMessage.value = '';

      clearModuleData()
    }

    await getGoalsFromLastMeeting();
  } catch (error) {
    await ErrorToast(error);
  }
}


function clearModuleData() {
  formData.value.moduleGoal1Id = null;
  formData.value.moduleGoal2Id = null;
  formData.value.moduleGoal3Id = null;
  formData.value.moduleGoal4Id = null;
  formData.value.moduleGoal5Id = null;
  formData.value.moduleGoal6Id = null;
  formData.value.moduleGoalDate = null;

  moduleGoal1Dropdown.value = [];
  moduleGoal2Dropdown.value = [];
  moduleGoal3Dropdown.value = [];
  moduleGoal4Dropdown.value = [];
  moduleGoal5Dropdown.value = [];
  moduleGoal6Dropdown.value = [];
}

async function onChangeGoal(newValue, dropdownId) {
  const dropdowns = [
    moduleGoal1Dropdown,
    moduleGoal2Dropdown,
    moduleGoal3Dropdown,
    moduleGoal4Dropdown,
    moduleGoal5Dropdown,
    moduleGoal6Dropdown,
  ];

  const goalNames = {
    goal1Name,
    goal2Name,
    goal3Name,
    goal4Name,
    goal6Name,
  };

  for (let i = dropdownId + 1; i <= 6; i++) { // Reset goals ids
    formData.value[`moduleGoal${i}Id`] = null;
  }

  await handleGoalChange(+formData.value.moduleId, newValue, dropdownId, dropdowns, goalNames, portalPrivateCoachingService);
}

async function onChangePresence(newValue) {

  if (newValue === 'unentschuldigt' || newValue === 'krank') {
    formData.value.moduleGoal1Id = null;
    formData.value.moduleGoal2Id = null;
    formData.value.moduleGoal3Id = null;
    formData.value.moduleGoal4Id = null;
    formData.value.moduleGoalDate = null;

    formRules.value = {
      ...formRules.value,
      moduleGoal1Id: '',
      moduleGoal2Id: '',
      moduleGoal3Id: '',
      moduleGoal4Id: '',
    };
  } else {
    formRules.value = {
      ...formRules.value,
      moduleGoal1Id: requiredRule(t),
      moduleGoal2Id: requiredRule(t),
      moduleGoal3Id: requiredRule(t),
      moduleGoal4Id: requiredRule(t),
    };
  }

  // api call
  const {data} = await portalPrivateCoachingService.checkMeetingPresenceOnChange({
    coachingId: coachingId.value, // Must be int
    presence: newValue,
    termin: formData.value.termin,
    meetingId: protocolId.value !== '' ? +protocolId.value : null,
  });

  formData.value.presenceRemainder = '';
  formData.value.presenceRemainderAcceptance = '';
  showAdditionalDropdown.value = false;

  formData.value.presenceRemainder = data?.data?.text;
  showAdditionalDropdown.value = data?.data?.showAdditionalDropdown;

  calculateTimeDifference();
}

async function getGoalsFromLastMeeting() {
  try {
    const {data} = await portalPrivateCoachingService.getGoalFromLastMeeting(
        {
          coachingId: coachingId.value,
          termin: formData.value.termin,
          meetingId: protocolId.value !== '' ? +protocolId.value : null,
        },
    );

    moduleGoal5LastMeetingDropdown.value = data?.data?.goal5DropdownFromLastMeetingData || [];
    moduleGoal6LastMeetingDropdown.value = data?.data?.goal6DropdownFromLastMeetingData || [];

    formData.value.moduleIdFromLastMeeting = data?.data?.lastMeetingModuleId;
    formData.value.lastMeetingId = data?.data?.lastMeetingId;
    formData.value.moduleGoal4IdFromLastMeeting = data?.data?.goal4IdFromLastMeeting;
    //formData.value.moduleGoal5IdFromLastMeeting = data?.data?.selectedGoal5FromLastMeeting;
    //formData.value.moduleGoal6IdFromLastMeeting = data?.data?.selectedGoal6FromLastMeeting;

  } catch (error) {
    await ErrorToast(error);
  }
}

async function onChangeGoalFromLastMeeting(newValue) {
  const {data} = await portalPrivateCoachingService.getGoalsOnChangeModuleOrGoal(
      formData.value.moduleIdFromLastMeeting, newValue,
  );

  moduleGoal6LastMeetingDropdown.value =
      data?.data?.moduleGoals?.filter(item => item.shortName)
          .map(item => ({
            label: item.shortName,
            value: item?.id,
          }));
}

async function getEnumsDropdown() {
  presenceDropdown.value = getEnums?.value?.presenceTypes || [];
}

const hoursArrayDropdown = computed(() => {
  return originalIsSystemAddedMeeting.value
      ? generateHoursArray(20, 20)
      : generateHoursArray(7, 20);
});


const minutesArrayDropdown = computed(() => {
  return originalIsSystemAddedMeeting.value
      ? ["00", "45"]
      : ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]
})

function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;
    isSystemAddedMeeting.value = false;

    formRules.value = {
      ...formRules.value,
      sectionNumber: requiredRule(t),
    }

    if (originalIsSystemAddedMeeting.value === true) {
      formRules.value = {
        ...formRules.value,
        moduleGoal1Id: '',
        moduleGoal2Id: '',
        moduleGoal3Id: '',
        moduleGoal4Id: '',
      }
    }
  } else {
    // restore form data from original snapshot
    formData.value = JSON.parse(JSON.stringify(originalFormData.value));

    formData.value.startTime = originalFormData.value.startTime;
    startTimeKey.value = originalFormData.value.startTime + '_' + Date.now(); // Change the key to force re-render

    formData.value.endTime = originalFormData.value.endTime;
    endTimeKey.value = originalFormData.value.endTime + '_' + Date.now(); // Change the key to force re-render

    moduleGoal1Dropdown.value = originalModuleGoalDropdowns.value?.goal1Dropdown || [];
    moduleGoal2Dropdown.value = originalModuleGoalDropdowns.value?.goal2Dropdown || [];
    moduleGoal3Dropdown.value = originalModuleGoalDropdowns.value?.goal3Dropdown || [];
    moduleGoal4Dropdown.value = originalModuleGoalDropdowns.value?.goal4Dropdown || [];
    moduleGoal5Dropdown.value = originalModuleGoalDropdowns.value?.goal5Dropdown || [];
    moduleGoal6Dropdown.value = originalModuleGoalDropdowns.value?.goal6Dropdown || [];
    moduleGoal5LastMeetingDropdown.value = originalModuleGoalDropdowns.value?.goal5FromLastMeetingDropdown || [];
    moduleGoal6LastMeetingDropdown.value = originalModuleGoalDropdowns.value?.goal6FromLastMeetingDropdown || [];

    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;
    isSystemAddedMeeting.value = originalIsSystemAddedMeeting.value

    unitsErrorMessage.value = ''
    terminErrorMessage.value = ''
    moduleInfoMessage.value = ''
    moduleUnitsErrorMessage.value = ''

    formRules.value = {
      ...formRules.value,
      sectionNumber: '',
    }
  }
}

function normalizeId(value) {
  if (value === '' || value === 'null' || value == null) {
    return null;
  }
  return Number(value);
}

const showUpdateAsAdminButton = computed(() =>
    (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    protocolId.value != null && protocolId.value !== ''
);


onMounted(async () => {
  CloseToast();
  if (companyKey !== "BSG") {
    await router.push({name: 'privateCoachingMICV2List'});
  }

  await Promise.all([
    getAssignedCoachesForDropdown(coachingId.value),
    getAssignedCoachesForDropdown(coachingId.value),
    getAssignedModulesForDropdown(coachingId.value),
    getEnumsDropdown(),
  ]);

  if (protocolId.value) {
    await getProtocolData(protocolId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>